import React from 'react';
import SelectFilter from '../SelectFilter/SelectFilter';
import { CustomTipType } from '@ready/dashboardv2api.contracts';
import { CUSTOM_TIP_TYPE_OPTIONS } from './constants';
import styles from './CustomTipSelector.module.scss';

export interface CustomTipSelectorProps {
  /** Current selected custom tip type */
  value: CustomTipType;
  /** Callback when selection changes */
  onChange: (value: CustomTipType | undefined) => void;
  /** Loading state */
  loading?: boolean;
  /** Additional CSS classes */
  className?: string;
  /** Placeholder text */
  placeholder?: string;
}



const CustomTipSelector: React.FC<CustomTipSelectorProps> = ({
  value,
  onChange,
  loading = false,
  className = '',
  placeholder = 'Select tip type',
}) => {
  const selectedOption = CUSTOM_TIP_TYPE_OPTIONS.find(option => option.value === value) || null;

  const handleChange = (option: typeof CUSTOM_TIP_TYPE_OPTIONS[0] | null) => {
    onChange(option?.value);
  };

  return (
    <div className={`${styles.customTipSelector} ${className}`}>
      <SelectFilter
        options={CUSTOM_TIP_TYPE_OPTIONS}
        value={selectedOption}
        onChange={handleChange}
        placeholder={placeholder}
        loading={loading}
      />
    </div>
  );
};

export default CustomTipSelector;
